<template>
    <v-tabs
      class="d-none d-sm-none d-md-flex"
    >
<v-tab @click="$router.push('/vascular/'), tableDescription = ''">
<span class="text-regular">Vascular </span> home
</v-tab>

<v-tab 
  @click="tableDescription = 'vascular_species_main'"
>
Species
<v-menu activator="parent">
  <v-list>
    <v-list-item
      v-for="(item, index) in items"
      :key="index"
      :value="index"
      @click="$router.push('/vascular/table/'+item.idlink)"
    >
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</v-tab>

<v-tab 
  @click="tableDescription = 'vascular_specimen_main'"
>
Specimens
<v-menu activator="parent">
  <v-list>
    <v-list-item
      v-for="(item, index) in items"
      :key="index"
      :value="index"
      @click="$router.push('/vascular/table/'+item.idlink)"
    >
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</v-tab>

<v-tab 
  @click="tableDescription = 'allspecies'"
>
Service tables
<v-menu activator="parent">
  <v-list>
    <v-list-item
      v-for="(item, index) in items"
      :key="index"
      :value="index"
      @click="$router.push('/table/'+item.idlink)"
    >
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</v-tab>


<v-tab @click="$router.push('/contacts/')">Contacts</v-tab>
<v-tab v-if="$store.state.loggedin" @click="$router.push('/login')">Login</v-tab>
</v-tabs>
 
<!--mobile version of menu-->
<div>
<v-btn
      color="regular"
      variant="text"
      @click.stop="drawer = !drawer"
      class="d-flex d-sm-none d-none d-sm-flex d-md-none px-2"
    >
      <strong>Menu</strong><svg-icon type="mdi" :path="mdiDotsVertical"/>
</v-btn>
</div>

    <v-navigation-drawer
        v-model="drawer"
        temporary
    >
        <v-tabs
          direction="vertical"
        >
          <v-list >
            <v-tab class="px-2" @click.stop="drawer = !drawer" @click="$router.push('/vascular/'), tableDescription = ''"><span class="text-regular">Hepatics </span><span class="px-0"> home</span></v-tab>
            <v-tab 
              @click="tableDescription = 'vascular_species_main'"
            >
            Species
            <v-menu activator="parent" location=center>
              <v-list>
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  :value="index"
                  @click="$router.push('/vascular/table/'+item.idlink), drawer = !drawer"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            </v-tab>

            <v-tab 
              @click="tableDescription = 'vascular_specimen_main'"
            >
            Specimens
            <v-menu activator="parent" location=center>
              <v-list>
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  :value="index"
                  @click="$router.push('/vascular/table/'+item.idlink), drawer = !drawer"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            </v-tab>
            <v-tab @click.stop="$router.push('/contacts'), drawer = !drawer">Contact</v-tab>
          </v-list>  
        </v-tabs>
    </v-navigation-drawer>

</template>

<script>
import axios from 'axios';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiDotsVertical } from '@mdi/js';
export default {
  name: 'VaHeader',
  components: {
    SvgIcon,
  },
  data(){ 
    return {
      mdiDotsVertical:mdiDotsVertical,
      drawer: false,
      tableDescription: '',
      allTableStructurLink: this.$store.state.mainurl+'/dataset/list?f=100&f_description=',
      items: [],
    }
  },

  watch: {
  tableDescription() {
    this.items = []; //claer items before create new items massif.
    if (this.tableDescription!=''){
      axios.get(this.allTableStructurLink+this.tableDescription).then((response) => {
        let itemsarray = response.data.aaData;
        for (let i = 0; i < itemsarray.length; i++) {
          this.items.push({ title: itemsarray[i].name, idlink: itemsarray[i].id, descriptiontype: itemsarray[i].description });
        }
      });
    }
  },
},

};
</script>